var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"height-wrapper"},[_c('Header'),_c('Transition',{attrs:{"name":"fade"}},[_c('RouterView')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }